import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import jwtDecode from "jwt-decode";
import { MenuAccess } from "../utils/menuOptions";

const useAuth = () => {
	const token = useSelector((state: RootState) => state.auth)?.token;
	// The raw claim, so that a refreshed token with the same menus keeps the same `menuOptions`
	// array. Tokens are replaced about every 5 minutes, and effects that depend on `menuOptions`
	// (the Header's notification effect among them) used to rerun, and refetch, on each one.
	const menuClaim: string | null = useMemo(() => {
		if (!token) {
			return null;
		}
		try {
			const decodedJwt: any = jwtDecode(token);
			return decodedJwt?.MenuOptions || null;
		} catch (error) {
			return null;
		}
	}, [token]);
	const menuOptions: MenuAccess[] | null = useMemo(
		() => (menuClaim ? (menuClaim.split(",") as MenuAccess[]) : null),
		[menuClaim]
	);

	return {
		token,
		isLoggedIn: !!token,
		menuOptions,
	};
};

export default useAuth;
